import {RoutingModel} from "../../common/models/routing";
import RouteSwitch from "../../helpers/routeSwitch";
import GeneralDeclarationList from "../components/generalDeclaration/generalDeclarationList/generalDeclarationList";
import {UserRoles} from "../../helpers/userRoles";
import GeneralDeclarationDetails from "../components/generalDeclaration/generalDeclarationDetails/generalDeclarationDetails";
import ManifestList from "../components/manifests/manifestsList/manifestsList";
import ManifestDetails from "../components/manifests/manifestDetails/manifestDetails";

enum generalDeclarationRoutingAddress {
    generalDeclaration = "/documents/general-declaration",
    list = "/documents/general-declaration/list",
    details = "/documents/general-declaration/details"
}

enum manifestsRoutingAddress {
    manifests = "/documents/manifests",
    list = "/documents/manifests/list",
    details = "/documents/manifests/entry"
}

export const documentsRoutingAddress = {
    generalDeclaration: generalDeclarationRoutingAddress,
    manifests: manifestsRoutingAddress
};

export const documentsRoutes: RoutingModel[] = [
    {
        path: documentsRoutingAddress.generalDeclaration.generalDeclaration,
        component: RouteSwitch,
        routes: [
            {
                path: documentsRoutingAddress.generalDeclaration.list,
                component: GeneralDeclarationList,
                roles: [UserRoles.documentsView]
            },
            {
                path: `${documentsRoutingAddress.generalDeclaration.details}/:id`,
                component: GeneralDeclarationDetails,
                roles: [UserRoles.documentsView]
            }
        ]
    },
    {
        path: documentsRoutingAddress.manifests.manifests,
        component: RouteSwitch,
        routes: [
            {
                path: documentsRoutingAddress.manifests.list,
                component: ManifestList,
                roles: [UserRoles.documentsView]
            },
            {
                path: `${documentsRoutingAddress.manifests.details}/:id`,
                component: ManifestDetails,
                roles: [UserRoles.documentsView]
            }
        ]
    }
];
